const da = {
    common: {
        history: "historisk version"
    }
};
export default da;



// WEBPACK FOOTER //
// ./src/i18n/langs/da.js